export default function dataCyReplace(text) {
  const regex = new RegExp(/\s/g);
  return (text ?? '').replace(regex, '_');
}
